import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { ref, get, getDatabase } from "firebase/database";
import "./Navbar.css";

function Navbar() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const db = getDatabase();

  // ✅ ตรวจสอบสถานะการล็อกอิน + สิทธิ์ admin
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        try {
          const adminRef = ref(db, `admin/${u.uid}`);
          const snapshot = await get(adminRef);
          setIsAdmin(snapshot.exists()); // ✅ ถ้ามี uid อยู่ใน admin → เป็นแอดมิน
        } catch (error) {
          console.error("Error checking admin role:", error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, [db]);

  // ✅ ปิดเมนู overlay เมื่อขยายจอ
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ ออกจากระบบ
  const handleLogout = () => {
    signOut(getAuth()).then(() => {
      setUser(null);
      setIsAdmin(false);
      navigate("/");
    });
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-light fixed-top"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div className="container-fluid position-relative">
          {/* โลโก้ */}
          <Link
            className="navbar-brand d-flex align-items-center"
            to="/"
            onClick={() => setMenuOpen(false)}
            style={{
              fontSize: "1.75rem",
              color: "#004085",
              textDecoration: "none",
            }}
          >
            <img
              src="/logo2.png"
              alt="Logo"
              style={{ height: "36px", marginRight: "10px" }}
            />
            KSN2018
          </Link>

          {/* ปุ่ม Hamburger สำหรับมือถือ */}
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            onClick={() => setMenuOpen(true)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* เมนูแนวนอน (Desktop) */}
          <div className="collapse navbar-collapse justify-content-end d-none d-lg-flex">
            <ul className="navbar-nav">
              {/* เมนูทั่วไป */}
              <li className="nav-item">
                <Link className="nav-link text-white" to="/">
                  หน้าหลัก
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="/contact">
                  ติดต่อ
                </Link>
              </li>

              {user && (
                <>
                  <li className="nav-item">
                    <Link
                      className="nav-link text-white"
                      to="/dashboard/usage"
                    >
                      การใช้งาน
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      className="nav-link text-white"
                      to="/dashboard/report"
                    >
                      รายงาน
                    </Link>
                  </li>
                   <li className="nav-item">
                        <Link
                          className="nav-link text-white"
                          to="/dashboard/settings"
                        >
                          ตั้งค่า
                        </Link>
                      </li>

                  {/* ✅ เฉพาะ Admin เท่านั้น */}
                  {isAdmin && (
                    <>
                      <li className="nav-item">
                        <Link
                          className="nav-link text-white"
                          to="/dashboard/group"
                        >
                          จัดกลุ่ม
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link text-white"
                          to="/dashboard/permissions"
                        >
                          กำหนดสิทธิ
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link text-white"
                          to="/dashboard/timesetting"
                        >
                          กำหนดเวลา
                        </Link>
                      </li>
                     
                    </>
                  )}
                </>
              )}

              {/* ปุ่ม Login / Logout */}
              {!user ? (
                <li className="nav-item">
                  <Link className="nav-link text-white" to="/login">
                    เข้าสู่ระบบ
                  </Link>
                </li>
              ) : (
                <li className="nav-item">
                  <button
                    className="nav-link text-white btn btn-link"
                    onClick={handleLogout}
                  >
                    ออกจากระบบ
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>

      {/* เมนูเต็มจอ (มือถือ) */}
      {menuOpen && (
        <div
          className="d-lg-none"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#005B85",
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* ปุ่มปิดเมนู */}
          <button
            onClick={() => setMenuOpen(false)}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              fontSize: "2rem",
              background: "none",
              border: "none",
              color: "white",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          {/* เมนูแนวตั้งแบบเต็มจอ */}
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            className="fs-4 mb-3 text-white"
          >
            หน้าหลัก
          </Link>
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="fs-4 mb-3 text-white"
          >
            ติดต่อ
          </Link>

          {user && (
            <>
              <Link
                to="/dashboard/usage"
                onClick={() => setMenuOpen(false)}
                className="fs-4 mb-3 text-white"
              >
                การใช้งาน
              </Link>
              <Link
                to="/dashboard/report"
                onClick={() => setMenuOpen(false)}
                className="fs-4 mb-3 text-white"
              >
                รายงาน
              </Link>
               <Link
                    to="/dashboard/settings"
                    onClick={() => setMenuOpen(false)}
                    className="fs-4 mb-3 text-white"
                  >
                    ตั้งค่า
                  </Link>

              {/* ✅ เฉพาะ Admin */}
              {isAdmin && (
                <>
                  <Link
                    to="/dashboard/group"
                    onClick={() => setMenuOpen(false)}
                    className="fs-4 mb-3 text-white"
                  >
                    จัดกลุ่ม
                  </Link>
                  <Link
                    to="/dashboard/permissions"
                    onClick={() => setMenuOpen(false)}
                    className="fs-4 mb-3 text-white"
                  >
                    กำหนดสิทธิ
                  </Link>
                  <Link
                    to="/dashboard/timesetting"
                    onClick={() => setMenuOpen(false)}
                    className="fs-4 mb-3 text-white"
                  >
                    กำหนดเวลา
                  </Link>
                 
                </>
              )}

              <button
                onClick={() => {
                  handleLogout();
                  setMenuOpen(false);
                }}
                className="fs-4 mt-3 btn btn-link text-white"
              >
                ออกจากระบบ
              </button>
            </>
          )}

          {!user && (
            <Link
              to="/login"
              onClick={() => setMenuOpen(false)}
              className="fs-4 mt-3 text-white"
            >
              เข้าสู่ระบบ
            </Link>
          )}
        </div>
      )}
    </>
  );
}

export default Navbar;
